import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcChatSmallOl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.5 2.25H19.5C20.7426 2.25 21.75 3.25736 21.75 4.5V14.5C21.75 15.7426 20.7426 16.75 19.5 16.75H10.2L6.1 20.55C5.45 21.15 4.4 20.69 4.4 19.8V16.75H4.5C3.25736 16.75 2.25 15.7426 2.25 14.5V4.5C2.25 3.25736 3.25736 2.25 4.5 2.25ZM4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5V14.5C3.75 14.9142 4.08579 15.25 4.5 15.25H5.9V18.6L9.6 15.25H19.5C19.9142 15.25 20.25 14.9142 20.25 14.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75H4.5ZM7.75 7.25H16.25V8.75H7.75V7.25ZM7.75 10.75H13.25V12.25H7.75V10.75Z",
		fill: "inherit"
	})
});
export default SvgIcChatSmallOl;
